import {
    CLEAR,
    USER_GET_REQUEST,
    USER_GET_SUCCESSFUL,
    USER_GET_PROFILE_SERVICES_WITH_STATUS,
    USER_GET_PROFILE_SERVICES_WITH_STATUS_SUCCESSFUL,
    AGREE_TO_TERMS_OF_USE_REQUEST,
    USER_GET_FAILED,
    USER_UPDATE_REQUEST,
    USER_PROFILE_UPDATE_REQUEST,
    USER_UPDATE_SUCCESSFUL,
    USER_UPDATE_FAILED,
    USER_CHANGE_PASSWORD_REQUEST,
    USER_CHANGE_PASSWORD_SUCCESSFUL,
    USER_CHANGE_PASSWORD_FAILED,
    USER_SEND_LOST_PASSWORD_REQUEST,
    USER_SEND_LOST_PASSWORD_SUCCESSFUL,
    USER_SEND_LOST_PASSWORD_FAILED,
    USER_RESET_PASSWORD_REQUEST,
    USER_RESET_PASSWORD_SUCCESSFUL,
    USER_RESET_PASSWORD_FAILED,
    USER_UPLOAD_SELECTED_USER_DOCUMENT_REQUEST,
    USER_UPDATE_DOCUMENTS_FILES,
    USER_SAVE_DOCUMENTS_FORM,
    USER_SET_PROFILE_TAB,
    USER_PROFILE_UPDATE_SUCCESSFUL,
    USER_PROFILE_UPDATE_FAILED,
    GET_MOBILITY_PLANS,
    SET_MOBILITY_PLANS,
    USER_SUBSCRIBE_TO_A_PLAN,
    USER_UNSUBSCRIBE_FROM_A_PLAN,
    USER_UPDATE_METHOD_OF_PAYMENT_SUCCESS,
    USER_UPDATE_METHOD_OF_PAYMENT_FAILURE,
    USER_GET_PAYMENT_DETAILS,
    USER_GET_PAYMENT_DETAILS_SUCCESS,
    USER_GET_PAYMENT_DETAILS_FAILURE,
    USER_REQUEST_ACCOUNT_DELETION,
    USER_GET_PUBKEY_INTENT,
    SETUP_MOBILITY_PLAN_PAGE,
    USER_SET_SUBSCRIPTIONS,
    USER_SET_SUBSCRIPTIONS_FETCHING,
    USER_SET_SUBSCRIPTIONS_UPDATING,
    USER_SWITCH_PLAN,
    USER_GET_ONGOING_TRIPS,
    USER_SET_ONGOING_TRIPS_LOADING,
    USER_SET_ONGOING_TRIPS,
} from './types';

export const clear = () => ({ type: CLEAR });

// user (get & update)
export const userGetRequest = payload => ({ type: USER_GET_REQUEST, payload });
export const userGetSuccessful = data => ({
    type: USER_GET_SUCCESSFUL,
    payload: data,
});
export const userGetProfileServicesWithStatuses = () => ({
    type: USER_GET_PROFILE_SERVICES_WITH_STATUS,
});

export const userGetProfileServicesWithStatusesSuccessful = data => ({
    type: USER_GET_PROFILE_SERVICES_WITH_STATUS_SUCCESSFUL,
    payload: data,
});

export const userGetFailed = () => ({ type: USER_GET_FAILED });
export const userUpdateRequest = data => ({
    type: USER_UPDATE_REQUEST,
    payload: data,
});
export const userUpdateSuccessful = () => ({ type: USER_UPDATE_SUCCESSFUL });
export const userUpdateFailed = () => ({ type: USER_UPDATE_FAILED });

// profile (update)
export const userProfileUpdateRequest = data => ({
    type: USER_PROFILE_UPDATE_REQUEST,
    payload: data,
});
export const userProfileUpdateSuccessful = () => ({
    type: USER_PROFILE_UPDATE_SUCCESSFUL,
});
export const userProfileUpdateFailed = () => ({
    type: USER_PROFILE_UPDATE_FAILED,
});

// password
export const userChangePasswordRequest = (username, currentPassword, newPassword) => ({
    type: USER_CHANGE_PASSWORD_REQUEST,
    payload: { username, currentPassword, newPassword },
});
export const userChangePasswordSuccessful = () => ({
    type: USER_CHANGE_PASSWORD_SUCCESSFUL,
});
export const userChangePasswordFailed = () => ({
    type: USER_CHANGE_PASSWORD_FAILED,
});
export const userSendLostPasswordRequest = (email, reCAPTCHAsiteKey) => ({
    type: USER_SEND_LOST_PASSWORD_REQUEST,
    payload: { email, reCAPTCHAsiteKey },
});
export const userSendLostPasswordSuccessful = () => ({
    type: USER_SEND_LOST_PASSWORD_SUCCESSFUL,
});
export const userSendLostPasswordFailed = () => ({
    type: USER_SEND_LOST_PASSWORD_FAILED,
});
export const userResetPasswordRequest = (token, password) => ({
    type: USER_RESET_PASSWORD_REQUEST,
    payload: { token, password },
});
export const userResetPasswordSuccessful = () => ({
    type: USER_RESET_PASSWORD_SUCCESSFUL,
});
export const userResetPasswordFailed = () => ({
    type: USER_RESET_PASSWORD_FAILED,
});

export const userUploadDocumentAttachementAction = payload => ({
    type: USER_UPLOAD_SELECTED_USER_DOCUMENT_REQUEST,
    payload,
});
export const userUpdateDocumentFiles = payload => ({
    type: USER_UPDATE_DOCUMENTS_FILES,
    payload,
});

export const userSaveDocumentFormAction = payload => ({
    type: USER_SAVE_DOCUMENTS_FORM,
    payload,
});

export const userChangeProfileTab = payload => ({
    type: USER_SET_PROFILE_TAB,
    payload,
});

export const agreeToTermsOfUseRequest = () => ({
    type: AGREE_TO_TERMS_OF_USE_REQUEST,
});

export const getMobilityPlans = () => ({ type: GET_MOBILITY_PLANS });
export const setMobilityPlans = payload => ({ type: SET_MOBILITY_PLANS, payload });
export const setupMobilityPlanPage = () => ({ type: SETUP_MOBILITY_PLAN_PAGE });
export const subscribeToAPlan = payload => ({ type: USER_SUBSCRIBE_TO_A_PLAN, payload });
export const unsubscribeFromAPlan = payload => ({ type: USER_UNSUBSCRIBE_FROM_A_PLAN, payload });
export const switchPlan = payload => ({ type: USER_SWITCH_PLAN, payload });
export const updateMethodOfPaymentSuccess = payload => ({ type: USER_UPDATE_METHOD_OF_PAYMENT_SUCCESS, payload });
export const updateMethodOfPaymentFailure = () => ({ type: USER_UPDATE_METHOD_OF_PAYMENT_FAILURE });
export const getPaymentDetails = () => ({ type: USER_GET_PAYMENT_DETAILS });
export const getPaymentDetailsSuccess = payload => ({ type: USER_GET_PAYMENT_DETAILS_SUCCESS, payload });
export const getPaymentDetailsFailure = () => ({ type: USER_GET_PAYMENT_DETAILS_FAILURE });
export const requestAccountDeletionAction = () => ({ type: USER_REQUEST_ACCOUNT_DELETION });
export const getPubKeyIntent = () => ({ type: USER_GET_PUBKEY_INTENT });
export const getPubKeyIntentSuccess = payload => ({ type: USER_GET_PUBKEY_INTENT, payload });
export const setSubscriptions = payload => ({ type: USER_SET_SUBSCRIPTIONS, payload });
export const setSubscriptionsFetching = payload => ({ type: USER_SET_SUBSCRIPTIONS_FETCHING, payload });
export const setSubscriptionsUpdating = payload => ({ type: USER_SET_SUBSCRIPTIONS_UPDATING, payload });
export const getOngoingTrips = () => ({
    type: USER_GET_ONGOING_TRIPS,
});
export const setOngoingTripsLoading = payload => ({
    type: USER_SET_ONGOING_TRIPS_LOADING,
    payload,
});
/**
 * Sets the ongoing trips in the user state.
 * @param {{ ids: string[], data: Object }} payload - The ongoing trips to set.
 * @returns {void}
 */
export const setOngoingTrips = payload => ({
    type: USER_SET_ONGOING_TRIPS,
    payload,
});
